import client from "@sanity/client"

export default client({
  projectId: "vmh5gsdm",
  dataset: "production",
  useCdn: true,
  apiVersion: "2021-08-05",
})
